<template>
  <div>
    <!-- <el-row class="typeAdmin">
      <el-col :span="12">
        <el-card class="typeAdmin">
          <el-tree class="filter-tree" :data="data" :expand-on-click-node="false" :props="defaultProps" default-expand-all :filter-node-method="filterNode" empty-text="暂无习题分类数据" ref="tree">
            <div slot-scope="{ data }" class="list_item">
              <el-row class="list_item_text" v-if="data.topTitle">
                <el-col :span="19">分类管理</el-col>
                <el-col :span="2" :offset="2">
                  <el-button size="mini" type="primary" @click="add">新增</el-button>
                </el-col>
              </el-row>
              <el-row class="list_item_text" v-else>
                <el-col :span="17" class="name">{{data.name}}</el-col>
                <el-col :span="6">
                  <el-button size="mini" type="primary" @click="action('edite',data)">编辑</el-button>
                  <el-button size="mini" type="primary" @click="action('stop',data)">{{data.publishStatus == 1 ? '启用' : '停用'}}</el-button>
                  <el-button size="mini" type="primary" @click="action('del',data)">删除</el-button>
                </el-col>
              </el-row>
            </div>
          </el-tree>
        </el-card>
      </el-col>
    </el-row> -->
    <el-card>
      <el-button type="primary" @click="add" v-if="checkAdmin()">新增</el-button>
    </el-card>
    <br />
    <el-table border v-loading="loading" :data="tableData" style="width: 100%">
      <el-table-column label="分类名称" prop="name" align="center" />
      <el-table-column label="操作" width="300" prop="name" align="center">
        <template slot-scope="{row}">
          <el-button size="mini" type="primary" @click="action('edite',row)" v-if="checkAdmin()">编辑</el-button>
          <el-button size="mini" type="primary" @click="action('stop',row)" v-if="checkAdmin()">
            {{row.publishStatus == 1 ? '启用' : '停用'}}
          </el-button>
          <el-button size="mini" type="primary" @click="action('del',row)" v-if="checkAdmin()">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <!-- 添加分类 -->
    <typeAdd ref="typeAdd" @update="reset" />
  </div>
</template>

<script>
import typeAdd from "./com/add.vue"
import tableMoudel from "@/libs/mixins/table"
import { examClassificationPage, examClassificationDel, examClassificationUpdate } from "../api"
export default {
  components: {
    typeAdd
  },
  mixins: [tableMoudel],
  data () {
    return {
      // defaultProps: {
      //   children: 'children',
      //   label: 'label'
      // },
      // data: [{
      //   id: 1,
      //   label: '分类管理',
      //   topTitle: true,
      //   children: []
      // }]
    }
  },
  created () {
    this.getData()
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    async getData () {
      const params = { ...this.pageInfo }
      const res = await examClassificationPage(params)
      if (res.code !== 0) return
      // this.data[0].children = res.data.records
      const { records, total } = res.data
      this.total = Number(total)
      this.tableData = records
    },
    reset () {
      this.pageInfo.page = 1
      this.getData()
    },
    add () {
      this.$refs.typeAdd.init()
    },
    async action (key, item) {
      switch (key) {
        case 'edite':
          this.$refs.typeAdd.init(item.id)
          break;
        case 'stop':
          const publishStatus = item.publishStatus == 1 ? 2 : 1
          const res = await examClassificationUpdate({ id: item.id, publishStatus })
          if (res.code !== 0) return this.$message.warning(res.message)
          this.$message.success('操作成功!')
          this.reset()
          break;
        case 'del':
          this.$confirm('是否确定删除当前学分类?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await examClassificationDel({ id: item.id })
            if (res.code !== 0) return this.$message.warning(res.message)
            this.$message.success('删除成功!')
            this.reset()
          })
          break;

        default:
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.typeAdmin {
  margin: 16px;
}
::v-deep .el-tree-node__content {
  height: auto;
}
.list_item {
  width: 100%;
  padding: 4px 0;
  .name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .list_item_text {
    width: 100%;
    display: inline-flex;
    align-items: center;
  }
}
</style>